export enum ETrainingMethod {
  ETRAINING = 'E-Training',
  SELFWORK = 'Selfwork',
  YOUTUBE = 'YouTube',
  BOOK = 'Book',
  MISC = 'Misc. (Other)',
}
